export default __webpack_public_path__ + "static/media/bg.7c1c8d14.jpg";